<template>

    <v-layout>
      <v-navigation-drawer floating permanent>
        <v-list density="compact" nav>

          <v-list-item class="preference-side-nav" :class="isFavActive" @click="changeTab('fav')">
            <v-icon medium class="mr-2">mdi-star</v-icon> <span>Medications</span>
          </v-list-item>

          <v-list-item class="preference-side-nav" :class="isICDActive" @click="changeTab('icd')">
            <v-icon medium class="mr-2">mdi-doctor</v-icon> <span>ICD</span>
          </v-list-item>

          <v-list-item class="preference-side-nav" :class="isTextActive" @click="changeTab('text')">
            <v-icon medium class="mr-2">mdi-text-box-edit</v-icon> <span>Text Replacement</span>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>
      <v-main style="height: 250px"></v-main>
    </v-layout>
</template>

<script>
export default {
  name: "SideNavigation",
  props: ['active'],
  computed: {
    isFavActive() {
        return {
            'active-tab': this.active == 'fav'
        }
    },
    isICDActive() {
        return {
            'active-tab': this.active == 'icd'
        }
    },
    isTextActive() {
        return {
            'active-tab': this.active == 'text'
        }
    }
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    changeTab (tab) {
        this.$parent.changeTab(tab);
    }
  }
};
</script>

<style scoped>
.preference-side-nav:hover {
    background: #258bf5 !important;
    cursor: pointer;
}

.preference-side-nav:hover .v-icon,
.preference-side-nav:hover span {
    color: white;
}

.active-tab {
    background: #258bf5 !important;
}

.active-tab span,
.active-tab .v-icon {
    color: white;
}

</style>